import { render, staticRenderFns } from "./Cropping.vue?vue&type=template&id=705a7404&scoped=true&"
import script from "./Cropping.vue?vue&type=script&lang=js&"
export * from "./Cropping.vue?vue&type=script&lang=js&"
import style0 from "./Cropping.vue?vue&type=style&index=0&id=705a7404&scoped=true&lang=css&"
import style1 from "./Cropping.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705a7404",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VFileInput,VIcon,VRow})
